/**
 * @generated SignedSource<<c882a38697234ca409bd2351e851cc92>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UserErrorCode = "INVALID_CREDENTIALS" | "INVALID_ARGUMENTS" | "UNAUTHORIZED_ACCESS" | "CONFLICTING_ORGANIZATIONS" | "RECORD_NOT_FOUND" | "%future added value";
export type DeleteGeneralAssetModelInput = {
  generalAssetModelId: string;
  clientMutationId?: string | null;
};
export type GeneralAssetModelsTableDeleteGeneralAssetModelMutation$variables = {
  input: DeleteGeneralAssetModelInput;
};
export type GeneralAssetModelsTableDeleteGeneralAssetModelMutationVariables = GeneralAssetModelsTableDeleteGeneralAssetModelMutation$variables;
export type GeneralAssetModelsTableDeleteGeneralAssetModelMutation$data = {
  readonly deleteGeneralAssetModel: {
    readonly generalAssetModel: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly code: UserErrorCode;
      readonly message: string;
    }>;
  } | null;
};
export type GeneralAssetModelsTableDeleteGeneralAssetModelMutationResponse = GeneralAssetModelsTableDeleteGeneralAssetModelMutation$data;
export type GeneralAssetModelsTableDeleteGeneralAssetModelMutation = {
  variables: GeneralAssetModelsTableDeleteGeneralAssetModelMutationVariables;
  response: GeneralAssetModelsTableDeleteGeneralAssetModelMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteGeneralAssetModelPayload",
    "kind": "LinkedField",
    "name": "deleteGeneralAssetModel",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GeneralAssetModel",
        "kind": "LinkedField",
        "name": "generalAssetModel",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GeneralAssetModelsTableDeleteGeneralAssetModelMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GeneralAssetModelsTableDeleteGeneralAssetModelMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "191844b37b60fa0fed8e0e06ce44a177",
    "id": null,
    "metadata": {},
    "name": "GeneralAssetModelsTableDeleteGeneralAssetModelMutation",
    "operationKind": "mutation",
    "text": "mutation GeneralAssetModelsTableDeleteGeneralAssetModelMutation(\n  $input: DeleteGeneralAssetModelInput!\n) {\n  deleteGeneralAssetModel(input: $input) {\n    generalAssetModel {\n      id\n      name\n    }\n    errors {\n      code\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "02d7ce1db1e305badfe21d4bae81f4a7";

export default node;
